import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Grid, Stack } from '@mui/material';
import DurationField from './DurationField.jsx';
import { COLORS, DEFAULT_DURATIONS } from './trafficLightState.mjs';

const t = (text) => window.__ ? window.__(text) : text;
const labels = { red: 'Red', amber: 'Amber', green: 'Green' };

export default function TrafficLightTimings({ light, onSave }) {
    const initialTimings = () => Object.fromEntries(COLORS.map((color) => [color,
        light.relays?.find((relay) => relay.action === color)?.timeout ?? light.timings?.[color] ?? DEFAULT_DURATIONS[color],
    ]));
    const [values, setValues] = useState(initialTimings);
    const [saving, setSaving] = useState(false);
    const [feedback, setFeedback] = useState(null);
    useEffect(() => { setValues(initialTimings()); }, [light.relays, light.timings]);

    const save = async (event) => {
        event.preventDefault();
        setSaving(true); setFeedback(null);
        try {
            await onSave(Object.fromEntries(COLORS.map((color) => [color, Number(values[color])])));
            setFeedback({ severity: 'success', message: t('Timings saved.') });
        } catch (error) {
            setFeedback({ severity: 'error', message: error.message });
        } finally { setSaving(false); }
    };

    return <Box component="form" onSubmit={save} aria-label={t('Color durations')}>
        <Stack spacing={1.5}>
            {feedback && <Alert severity={feedback.severity}>{feedback.message}</Alert>}
            <Grid container spacing={1}>
                {COLORS.map((color) => <Grid item xs={4} key={color}>
                    <DurationField fullWidth size="small" required fractional compact label={t(labels[color])}
                        value={values[color]} disabled={saving}
                        onChange={(seconds) => { setValues({ ...values, [color]: seconds }); setFeedback(null); }} />
                </Grid>)}
            </Grid>
            <Button type="submit" size="small" variant="outlined" disabled={saving}>{t(saving ? 'Saving...' : 'Save timings')}</Button>
        </Stack>
    </Box>;
}
